<template>
	<div class="left-panel">
		<div class="class-info-card">
			<h3>📚 课堂信息</h3>
			<div class="info-item">
				<span class="label">课堂名称：</span>
				<span class="value">{{ classInfo.courseName }}</span>
			</div>
			<div class="info-item">
				<span class="label">授课教师：</span>
				<span class="value">{{ classInfo.teacherName }}</span>
			</div>
			<div class="info-item">
				<span class="label">当前状态：</span>
				<span class="value status">
					{{ isClassEnded ? '✅ 课堂已结束' : (isLocked ? '已锁屏' : '正常授课') }}
				</span>
			</div>
		</div>

		<div class="tool-card" >
			<h3>🔧 实验工具</h3>
			<button
				class="tool-btn"
				@click="$emit('send-msg', '实验原理')"
				:disabled="isClassEnded || isLocked"
			>实验原理</button>
			<button
				class="tool-btn"
				@click="$emit('send-msg', '实验步骤')"
				:disabled="isClassEnded || isLocked"
			>实验步骤</button>
			<button
				class="tool-btn"
				@click="$emit('send-msg', '注意事项')"
				:disabled="isClassEnded || isLocked"
			>注意事项</button>
			<button
				class="tool-btn"
				@click="$emit('send-msg', '实验结论')"
				:disabled="isClassEnded || isLocked"
			>实验结论</button>
			<button
				class="tool-btn"
				@click="$emit('send-msg', '实验公式')"
				:disabled="isClassEnded || isLocked"
			>实验公式</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		classInfo: { type: Object, default: () => ({}) },
		isClassEnded: Boolean,
		isLocked: Boolean
	},
	data() {
		return{
			customPageId:localStorage.getItem('customPageId'),
			
		}
	}
};
</script>

<style scoped>
.left-panel {
	width: 320px; display: flex; flex-direction: column; gap: 20px;
}
.class-info-card, .tool-card {
	background: #fff; border-radius: 20px; padding: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}
h3 { font-size: 18px; margin-bottom: 16px; color: #667eea; }
.info-item { display: flex; margin: 10px 0; font-size: 15px; }
.label { color: #7b68ee; font-weight: bold; width: 100px; }
.value { font-weight: bold; }
.status { color: #10b981; }
.tool-btn {
	width: 100%; padding: 12px; margin: 8px 0;
	background: linear-gradient(135deg, #667eea, #764ba2);
	color: #fff; border: none; border-radius: 12px; font-weight: bold;
}
.tool-btn:disabled { background: #ccc; }
</style>